export default language => ({
  headers: {
    'Accept-Language': language,
    'User-Agent': 'GHD'
  }
});
